class SituacaoService
  @$inject = ['genericServiceHelper']

  filterData: (data)->
    data = data[0]
    data.cstPisEntrada = data.cst_pis_entrada;
    data.cstPisSaida = data.cst_pis_saida;
    data.cstCofinsEntrada = data.cst_cofins_entrada;
    data.cstCofinsSaida = data.cst_cofins_saida;
    data.modificador = parseFloat(data.modificador);

    return data

  constructor: (serviceHelper) ->
    @helper = serviceHelper(
      url: '/eficiencia-fiscal/situacao/'
      screenId: '#eficiencia-fiscal'
      service: this,
      events:
        after:
          'get': @filterData
    )
angular.module('eficienciaFiscalModule').service('situacaoService', SituacaoService)
